import { useEffect, useState } from "react";
import useAxios from "../../../../Utils/useAxios";
import FeatureContainer from "../../../../Layout/Containers/FeatureContainer";
import GroupStafList from "../components/GroupStafList";
import GroupStafModal from "../components/GroupStafModal";
import getGroupStaf from "../services/getGroupStaf";

const GroupStafContain = () => {
  const [data, setData] = useState({ groupStaf: [] });
  const [pending, setPending] = useState(true);

  const axiosInstance = useAxios();

  let isMounted = true;
  useEffect(() => {
    const fetchData = async () => {
      refreshGroupStaf();
    };

    if (isMounted) fetchData();
    return () => {
      isMounted = false;
    };
  }, []);

  const refreshGroupStaf = async () => {
    setPending(true);

    getGroupStaf(axiosInstance)
      .then((res) => {
        setData((prev) => ({ ...prev, groupStaf: res.data }));
      })
      .finally(() => {
        setPending(false);
      });
  };

  return (
    <FeatureContainer
      createButton={
        <GroupStafModal create={true} resetState={refreshGroupStaf} />
      }
      type={"pengaturan"}
    >
      <GroupStafList
        items={data.groupStaf}
        resetState={refreshGroupStaf}
        pending={pending}
      />
    </FeatureContainer>
  );
};

export default GroupStafContain;
